import { getConfig } from 'src/config'

const config = getConfig()

export const createWebinar = async (webinarId: string, formValues: Record<string, string>) => {
  if (!formValues.email || !formValues.firstName || !formValues.lastName) {
    return Promise.reject(new Error('Email or firstName or lastName was not provided to create webinar'))
  }

  const formData = new URLSearchParams()
  formData.append('webinarId', webinarId)
  formData.append('email', formValues.email)
  formData.append('first_name', formValues.firstName)
  formData.append('last_name', formValues.lastName)

  return fetch(config.api.zoomWebinar, {
    method: 'POST',
    body: formData,
    mode: 'no-cors',
    redirect: 'follow',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}
